import { BaseRequest } from "../../../soap/BaseRequest";

export class MoveActivityRequest extends BaseRequest {
    public activity_id: string;
    public target_project_id: string;
    constructor(server: string, session: string, activity_id: string, target_project_id: string) {
        super(server, session);
        this.activity_id = activity_id;
        this.target_project_id = target_project_id;
    }

    public toQueryString(): string {
        let queryString = [];
        queryString.push(`instance=${this.server}`);
        queryString.push(`session=${this.session}`);
        queryString.push(`activity_id=${this.activity_id}`);  
        queryString.push(`target_project_id=${this.target_project_id}`);
        return queryString.join('&');
    }
}
